// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_i0-0";